import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Box from "@mui/material/Box";
import { alpha } from "@mui/material/styles";
export const PortalCard = React.forwardRef(function PortalCard({ interactive = false, accentColor, sx, children, ...rest }, ref) {
    return (_jsx(Box, { ref: ref, sx: [
            (theme) => ({
                position: "relative",
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                backgroundColor: theme.palette.background.paper,
                boxShadow: `0 1px 2px ${alpha("#0f172a", 0.04)}`,
                transition: "box-shadow 160ms ease, border-color 160ms ease, transform 160ms ease",
                ...(accentColor && {
                    overflow: "hidden",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        insetInlineStart: 0,
                        insetBlock: 0,
                        width: 3,
                        backgroundColor: accentColor,
                    },
                }),
                ...(interactive && {
                    "&:hover": {
                        transform: "translateY(-1px)",
                        borderColor: alpha(theme.palette.primary.main, 0.35),
                        boxShadow: `0 10px 28px -16px ${alpha("#0f172a", 0.35)}`,
                    },
                }),
                "@media (prefers-reduced-motion: reduce)": {
                    transition: "none",
                    "&:hover": { transform: "none" },
                },
            }),
            ...(Array.isArray(sx) ? sx : [sx]),
        ], ...rest, children: children }));
});
